// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"447":"forum/components/DeclarationModal","883":"forum/components/DeclarationInfoModal"}[chunkId] + ".js";
};